import React from "react";
import { languageService } from "../../../Language/language.service";
import { Col } from "reactstrap";
import { themeService } from "../../../theme/service/activeTheme.service";
import { trackReportStyle } from "../../Reports/Timps/style";
import SpinnerLoader from "../../Common/SpinnerLoader";
import BlueCardReportView from "../../BlueCardReport/BlueCardReportView";
import SvgIcon from "react-icons-kit";
import { printer } from "react-icons-kit/icomoon/printer";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import { CRUDFunction } from "../../../reduxCURD/container.js";
import moment from "moment";
import CertifyContainer from "../../BlueCardReport/BlueCardReportView/CertifyTest/CertifyContainer.jsx";
import { getLoggedInUser } from "../../MainPage/UserInfo.js";
import { ReportSelectorTable } from "../../../CommonUI/ReportSelectorTable/ReportSelectorTable.js";
class OOSBlueCardDetail extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      spinnerLoading: false,
      blueCardReport: null,
      OOSperiods: null,
      enhancedReportData: null,
      selectedPerformedByUser: null,
    };
    this.handlePerformedByUserChange = this.handlePerformedByUserChange.bind(this);
  }

  componentDidMount() {
    const assetId = this.props.asset.assetId;
    const year = this.props.asset.year;
    this.props.getBlueCards(`/getBlueCard?year=${year}&assetId=${assetId}`);
  }

  componentDidUpdate(prevProps, prevState) {
    const { actionType, BlueCardActionType } = this.props;
    const { blueCardReport, OOSperiods, enhancedReportData } = this.state;
    const assetId = this.props.asset.assetId;
    const year = this.props.asset.year;
    // BlueCard fetch states

    if (BlueCardActionType === "BLUECARDS_READ_REQUEST" && BlueCardActionType !== prevProps.BlueCardActionType) {
      this.setState({ spinnerLoading: true });
    }
    if (BlueCardActionType === "BLUECARDS_READ_SUCCESS" && BlueCardActionType !== prevProps.BlueCardActionType) {
      this.setState({ spinnerLoading: false, blueCardReport: this.props.BlueCards });
      this.props.getOOSPeriodDetails(`/getOOUPendingPeriods?year=${year}&assetId=${assetId}`);
    }
    // OOSPeriod fetch states
    if (actionType === "OOSPERIODDETAILS_READ_REQUEST" && actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: true });
    }
    if (actionType === "OOSPERIODDETAILS_READ_SUCCESS" && actionType !== prevProps.actionType) {
      const enhanced = this.enhanceBluecardData(blueCardReport, this.props.OOSPeriodDetails, this.props.reportType);
      this.setState({ spinnerLoading: false, OOSperiods: this.props.OOSPeriodDetails, enhancedReportData: enhanced });
    }
    if (actionType === "OOSPERIODDETAILS_READ_FAILURE" && actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: false });
    }
    if (BlueCardActionType === "BLUECARDS_READ_FAILURE" && BlueCardActionType !== prevProps.BlueCardActionType) {
      this.setState({ spinnerLoading: false });
    }
  }

  enhanceBluecardData(bluecardReport, oosPeriods, reportType) {
    if (reportType === "certified") {
      return bluecardReport;
    }
    if (!bluecardReport) bluecardReport = {};
    if (!oosPeriods) oosPeriods = {};
    const enhanced = { ...bluecardReport };
    const lookupArray =
      Array.isArray(oosPeriods.oouLookup) && oosPeriods.oouLookup[0] && Array.isArray(oosPeriods.oouLookup[0].opt2)
        ? oosPeriods.oouLookup[0].opt2
        : [];

    const existingOutOfUse = (enhanced.summary && enhanced.summary.OutOfUse) || {};
    const updatedOutOfUse = { ...existingOutOfUse };

    let periodCount = 0;
    Object.keys(existingOutOfUse).forEach((key) => {
      const match = key.match(/^period(\d+)Data$/);
      if (match) {
        const num = parseInt(match[1], 10);
        if (num > periodCount) periodCount = num;
      }
    });

    updatedOutOfUse.outOfUseCredit = existingOutOfUse.outOfUseCredit || 0;

    lookupArray.forEach((period, idx) => {
      const i = periodCount + idx + 1;

      updatedOutOfUse[`period${i}Id`] = period.id;
      updatedOutOfUse[`period${i}StartDate`] = period.start;
      updatedOutOfUse[`period${i}Data`] = { ...period };
      updatedOutOfUse[`period${i}blueCardCertify`] = { certify: true };
    });

    enhanced.summary = {
      ...enhanced.summary,
      OutOfUse: updatedOutOfUse,
    };
    return enhanced;
  }
  handlePerformedByUserChange(e) {
    this.setState({ selectedPerformedByUser: e.target.value });
  }

  render() {
    const { spinnerLoading, enhancedReportData, OOSperiods } = this.state;
    const { onBack, applicationlookupss } = this.props;

    const oouPreviousYearCols = [
      {
        id: "year",
        text: "Year",
        accessor: (period) => <span style={{ fontSize: "16px" }}>{moment(period.end).year()}</span>,
        width: "15%",
      },
      {
        id: "entry",
        text: "Out Of Use Entry",
        accessor: (period) => (
          <div
            style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", fontSize: "18px" }}
          >
            <span>
              {moment(period.start).format("MM-DD-YY")} to {moment(period.end).format("MM-DD-YY")}
            </span>
            <CertifyContainer oouPeriodDetails={period} assetId={this.props.asset.assetId} handleCertifyClick={onBack} type="oou" />
          </div>
        ),
      },
    ];

    const sortedPreviousYearPeriods =
      OOSperiods &&
      Array.isArray(OOSperiods.oouLookup) &&
      OOSperiods.oouLookup.length > 0 &&
      Array.isArray(OOSperiods.oouLookup[0].previousYearPeriods)
        ? [...OOSperiods.oouLookup[0].previousYearPeriods].sort((a, b) => moment(a.end).year() - moment(b.end).year())
        : [];

    return (
      <div>
        <SpinnerLoader spinnerLoading={spinnerLoading} />

        {!spinnerLoading && enhancedReportData && (
          <React.Fragment>
            <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px" }}>
              <div
                className="report-arrow"
                style={{ margin: "15px 15px 10px 0", cursor: "pointer", float: "left", textAlign: "center" }}
                onClick={onBack}
              >
                <span style={{ verticalAlign: "super", marginLeft: "5px", fontSize: "12px", display: "block" }}>
                  {languageService("Reports Menu")}
                </span>
                <SvgIcon icon={arrowLeft} size={24} />
              </div>
              <div
                className="report-print"
                style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
                onClick={() => window.print()}
              >
                <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
                  {languageService("Print Report")}
                </span>
                <SvgIcon icon={printer} size={24} />
              </div>
            </div>
            <BlueCardReportView
              reportData={enhancedReportData}
              year={this.props.asset && this.props.asset.year}
              selectedPerformedByUser={this.state.selectedPerformedByUser}
              handlePerformedByUserChange={this.handlePerformedByUserChange}
              blueCardSectionsLookups={applicationlookupss}
              handleCertifyClick={onBack}
            />
            {/* --- Previous‑Year OOS Entries --- */}
            {this.props.reportType === "pending" && sortedPreviousYearPeriods.length > 0 && (
              <React.Fragment>
                <div style={{ textAlign: "center", marginTop: "2rem" }}>
                  <h4 style={{ fontWeight: "bold", color: "#333" }}>{languageService("Previous Years Out Of Use Entries")}</h4>
                </div>
                <ReportSelectorTable
                  containerStyle={{ width: "90%", margin: "0 auto" }}
                  cols={oouPreviousYearCols}
                  data={sortedPreviousYearPeriods}
                />
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
};

const OOSBlueCardDetailContainer = CRUDFunction(OOSBlueCardDetail, "OOSPeriodDetail", actionOptions, null, [], "testSchedule");

export default OOSBlueCardDetailContainer;



// WEBPACK FOOTER //
// ./src/components/ReviewsCertifications/OOS/OOSBlueCardDetail.jsx